import { configureStore } from "@reduxjs/toolkit";

import exampleReducer from "./example";

const store = configureStore({
  reducer: {
    exampleReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
